import { apiAction } from "@ROM-utils/actions";
import UnitsApi from "./api";

export const LIST = "units/api/LIST";

export function list(options = {}) {
  return apiAction(LIST, UnitsApi.list(options));
}
